module.exports = __webpack_public_path__ + "static/media/resume-secondary2.64dbe406.svg";